import createBlockDndPlugin from '@draft-js-plugins/drag-n-drop';
export const blockDndPlugin = createBlockDndPlugin();
